import { Component, OnDestroy, OnInit, ViewChild, TemplateRef, LOCALE_ID } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbDialogService, NbWindowService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { i18nModule } from '../../../i18n.module';
import { ActivatedRoute, Router } from '@angular/router';
import { AgentService } from '../../../@core/services/local/agent.service';
import { environment } from '../../../../environments/environment';
import { Environments } from '../../../@core/constants/Environments';
import { ResponseModalThemesComponent } from '../../modals/response-modal-themes/response-modal-themes.component';

// registerLocaleData(localeTr, 'tr-TR');

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentRouteAgent = this.activatedRoute.snapshot.queryParams['Agent']
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  @ViewChild('contentTemplate', { static: false }) contentTemplate: TemplateRef<any>;

  user: any;
  email: string;
  phone: string;
  agentName: string;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'corporate';

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private router: Router,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private translateModule: i18nModule,
    private activatedRoute: ActivatedRoute,
    private agentService: AgentService,
    private windowService: NbWindowService,
    private dialogService: NbDialogService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    let agentCodeUrl = this.activatedRoute.snapshot.queryParams['Agent'];

    if (agentCodeUrl != undefined) {
      this.agentService.getAgent().subscribe(data => {
        if (data == null) {
          var activeModal = this.dialogService.open(ResponseModalThemesComponent, { hasBackdrop: false, closeOnEsc: false });
          let instance = activeModal.componentRef.instance;
          instance.header = this.translateModule.getTranslatedValue("Warning");
          instance.status = "warning";
          instance.primaryText = this.translateModule.getTranslatedValue("AgentNotFound");
          instance.secondaryText = this.translateModule.getTranslatedValue("NavigateAgentlessLink");
          activeModal.onClose.subscribe(() => {
            this.router.navigate([''])
          });

        }
        else if (this.currentRouteAgent) {
          this.email = data.EMAIL;
          this.phone = data.PHONE;
          this.agentName = data.AGENT;
        }

      });
    }

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  backToHomePage() {
    this.router.navigate(['form'])
  }

  changeLang(langCode: string) {
    this.translateModule.onLangChange(langCode);
  }
  openWindow() {
    this.windowService.open(
      this.contentTemplate,
      { title: `İş Ortağı Bilgileri`, context: { text: 'some text to pass into template' } },
    );
  }

  isTest() {
    return environment.env != Environments.PROD;
  }
}
